import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import DatePicker from "react-datepicker";
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Link, Tooltip } from "@mui/material";
import './bidding.css';
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import jwt from 'jwt-decode';
import { PROD } from "../../../common/constants";
import { authKey, GET_TRANSPORTER_BIDDING_LIST, DOWNLOAD_DOCUMENT, GET_BIDDING_DETAILS, ADD_BIDDING_DETAILS, GET_STAKEHOLDER_CATEGORY } from "../../../common/URLs";
import { loaderService } from "../../../common/custom-loader/loader-service";

import { toast } from 'react-toastify';
import { PIT_VALIDATIONS } from "../../../common/commonValidations";
import { Button, Container, Card, CardContent, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { FileIcon } from "../../../common/icons";
import moment from 'moment';
import apiClient from "../../../axios";

function TransporterAllBidding() {

    const decoded = jwt(getLocalStorageItem('id_token'));
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const [biddingData, setBiddingData] = useState();

    const columns = [
        // { field: 'allotmentRequestNumber', headerName: 'Request Number', width: 180 },
        {
            field: 'bidNumber', headerName: 'Bid Number', width: 290,
        },
        {
            field: 'allotmentQuantity', headerName: 'Quantity(MT)', type: 'number', width: 150,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'biddingStartDate', headerName: 'Bidding Start Date', width: 150,
            valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        },
        {
            field: 'biddingEndDate', headerName: 'Bidding End Date', width: 150,
            valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        },
        {
            field: 'biddingStartTime', headerName: 'Bidding Start Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }
        },
        {
            field: 'biddingEndTime', headerName: 'Bidding End Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }

        },
        {
            field: 'baseBidPrice', headerName: 'Base Rate(per ton per KM)', type: 'number', width: 180,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'biddingValue', headerName: 'Bidding Value', type: 'number', width: 150,
            valueGetter: params => params?.value?.toFixed(2),
        },
        {
            field: 'bidDocumentList',
            headerName: 'Documents',
            width: 300,
            renderCell: (params) => {
                const docs = params.value || [];
                if (docs.length === 0) return "No files";
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {docs.map((doc) => (
                            <Link
                                // key={index}
                                onClick={(e) => viewdownloadDocument(doc?.biddingTermsFileId, doc?.biddingTermsFileName, "Download")}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                            >
                                {doc.biddingTermsFileName}
                            </Link>
                        ))}
                    </div>
                );
            }
        },
    ];


    useEffect(() => {
        if (decoded.extension_URN) {
            getStakeDetails();
        }
    }, [decoded.extension_URN]);

    function getStakeDetails() {
        loaderService.showLoader()
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": decoded.extension_URN,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeholderDetails(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    useEffect(() => {
        if (stakeholderDetails?.urn) getBiddingDetails();
    }, [stakeholderDetails?.urn]);

    const getBiddingDetails = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_TRANSPORTER_BIDDING_LIST,
                {
                    "stakeholderUrn": stakeholderDetails?.urn
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            ).then((response) => {
                setBiddingData(response.data.spotBiddingDetailList);
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
        loaderService.showLoader();
        return fetch(DOWNLOAD_DOCUMENT,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": documentBlobName,
                    "containerName": "pit",
                    "file": ""
                })
            })
            .then((response) => response.blob()
            )
            .then((blob) => {
                if (type === "View") {
                    const fileName = finalfileName
                    const splittedName = fileName.split('.')
                    const fileExtension = splittedName[splittedName.length - 1];
                    let fileType;
                    switch (fileExtension) {
                        case 'pdf':
                            fileType = 'application/pdf';
                            break;
                        case 'png':
                            fileType = 'image/png';
                            break;
                        case 'jpg':
                            fileType = 'image/jpeg';
                            break;
                        case 'jpeg':
                            fileType = 'image/jpeg';
                            break;
                        default:
                            fileType = 'application/octet-stream';
                    }
                    const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                    const newWindow = window.open(url, '_blank');
                    newWindow.focus();
                }
                else {
                    const a = document.createElement("a");
                    a.style.display = "none";
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = finalfileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT32</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <Typography variant="h5" gutterBottom>
                        Bidding
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Box sx={{ height: 400, width: '100%' }}>
                            {biddingData &&
                                <DataGrid
                                    rows={biddingData}
                                    columns={columns}
                                    pageSize={5}
                                    rowsPerPageOptions={[5]}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    experimentalFeatures={{ newEditingApi: true }}
                                />
                            }
                        </Box>
                    </CardContent>
                </Card>
            </Container>

        </>
    )
}
export default TransporterAllBidding;